/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import ApiCaller from "~/api/ApiCaller";
import { GetActiveNewsResponse } from "~/features/news/types";

const NewsApi = {
  getActiveNews: () => ApiCaller.get<GetActiveNewsResponse>("/v1/news/activenews"),
};

export default NewsApi;
